import { useState } from 'react';

import { Button, Container, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Playlists from '~/components/ui/Playlists';
import { usePlaylistsSelector } from '~/store/slices/playlist-hook';

function PlaylistsResult() {
  const { t } = useTranslation('common');
  const playlistsFound = usePlaylistsSelector();
  const [maxDisplay, setMaxDisplay] = useState(3);

  return (
    <Container maxW='2xl'>
      <Stack display='flex' alignItems='center' minW='100%'>
        <Text fontFamily='heading' fontSize='32px' mb={6} fontWeight='500'>
          BAM Playlists
        </Text>

        <Stack spacing={6}>
          {(playlistsFound ?? []).slice(0, maxDisplay).map((playlistFound) => (
            <Playlists
              key={`playlist_tag_${playlistFound.tag}`}
              title={playlistFound.tag}
              playlists={playlistFound.playlists}
              linkText={t('actions.seeMore')}
            />
          ))}
        </Stack>

        {maxDisplay === Infinity ? (
          <Button variant='outline' size='sm' mt={10} onClick={() => setMaxDisplay(3)}>
            {t('actions.hideAllPlaylists')}
          </Button>
        ) : (
          <Button variant='outline' size='sm' mt={10} onClick={() => setMaxDisplay(Infinity)}>
            {t('actions.seeAllPlaylists')}
          </Button>
        )}
      </Stack>
    </Container>
  );
}

export default PlaylistsResult;
